var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBrush16(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1025_836)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.42503 10.0379C10.1834 9.93125 10.8667 9.50742 11.2917 8.86485L15.7834 2.02617C16.1334 1.49297 16.0445 0.787501 15.5722 0.352735C15.1 -0.0820302 14.3806 -0.120311 13.8639 0.262501L7.28892 5.11875C6.62225 5.61094 6.2278 6.3793 6.22225 7.19961L9.42503 10.0379ZM8.88058 10.7324L5.65836 7.87774C3.99725 7.93789 2.66669 9.28594 2.66669 10.9375C2.66669 11.0441 2.67225 11.1508 2.68336 11.2547C2.73336 11.7332 2.40003 12.25 1.91114 12.25H1.7778C1.28614 12.25 0.888916 12.641 0.888916 13.125C0.888916 13.609 1.28614 14 1.7778 14H5.7778C7.49725 14 8.88892 12.6301 8.88892 10.9375C8.88892 10.8691 8.88614 10.8008 8.88336 10.7324H8.88058Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1025_836"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrush16);
export default __webpack_public_path__ + "static/media/Brush16.9865046a199b43c72de00bb26e6c52cf.svg";
export { ForwardRef as ReactComponent };